module.exports = __webpack_public_path__ + "img/msg-send.244ffa6f.svg";